/* eslint-disable jsx-a11y/anchor-is-valid */
import { ChangeEvent, useState, type FC } from "react";

export interface FileUploadBoxProp {
  setFiles: (files: FileList | null) => void;
}

export const FileUploadBox: FC<FileUploadBoxProp> = (props) => {
  const [images, setImages] = useState<string[]>([]);

  const onImageSelected = async (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files ? Array.from(event.target.files) : [];
    if (files.length) {
      let imageList = [] as string[];
      for (const file of files) {
        let url = (await readURL(file as File)) as string;
        imageList.push(url);
      }
      setImages(imageList);
    }
  };

  const readURL = (file: File) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) =>
        resolve(e && e.target && e.target.result ? e.target.result : null);
      reader.onerror = (e) => reject(e);
      reader.readAsDataURL(file);
    });
  };
  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <label
          htmlFor="dropzone-file"
          className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
        >
          <div className="flex flex-col items-center justify-center pt-5 pb-6">
            <svg
              className="w-8 h-8 mb-4 text-muted"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 16"
            >
              <path
                stroke="currentColor"
                stroke-linejoin="round"
                d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
              />
            </svg>
            <p className="mb-2 text-sm text-muted">
              <span className="font-semibold">Click to upload</span> or drag and
              drop
            </p>
            <p className="text-xs text-muted">
              SVG, PNG, JPG or GIF (MAX. 800x400px)
            </p>
          </div>
          {images.length > 0 && (
            <div className="flex gap-4">
              {images.map((img) => {
                return (
                  <img
                    width={50}
                    src={img}
                    id="uploaded-image"
                    alt="Uploaded images"
                  />
                );
              })}
            </div>
          )}
          <input
            onChange={(e) => onImageSelected(e)}
            id="dropzone-file"
            multiple
            type="file"
            className="hidden"
          />
        </label>
      </div>
    </div>
  );
};
